import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Row, Col, Card } from 'react-bootstrap';
import Ticket from "./Ticket";

const EstadoTransaccion = ({ transaccion }) => {
  // Asegurando que transaccion.tickets siempre sea un array
  const tickets = Array.isArray(transaccion.tickets) ? transaccion.tickets : [];
  const cifras = Number(transaccion.cifras) || 0;
  const normalizarNumero = (numero) => {
    const numeroTexto = String(numero ?? "").trim();
    return cifras > 0 ? numeroTexto.padStart(cifras, "0") : numeroTexto;
  };
  const numerosPremiados = new Set(
    Array.isArray(transaccion.numerosPremiados)
      ? transaccion.numerosPremiados.map(normalizarNumero)
      : []
  );

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
      <h5 className="card-title text-center">
        Transacción procesada por: <strong>Mercado Pago</strong>
      </h5>
      <div className={`alert ${transaccion.estado === 'Aceptada' ? 'alert-success' : 'alert-danger'}`} role="alert">
        <h6 className="mb-0 text-center">
          <strong>TRANSACCIÓN {transaccion.estado.toUpperCase()}</strong><br />
          <span>${transaccion.monto * transaccion.cantidad } COP</span>
        </h6>
      </div>
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <i className="bi bi-person-fill me-2"></i>
          <strong>Comprador:</strong> {transaccion.comprador}
        </li>
        <li className="list-group-item">
          <i className="bi bi-envelope me-2"></i>
          <strong>Correo:</strong> {transaccion.correo}
        </li>
        <li className="list-group-item">
          <i className="bi bi-instagram me-2"></i>
          <strong>Instagram:</strong> {transaccion.instagram}
        </li>
        <li className="list-group-item">
          <i className="bi bi-receipt me-2"></i>
          <strong>Referencia:</strong> {transaccion.referencia}
        </li>
        <li className="list-group-item">
          <i className="bi bi-clock me-2"></i>
          <strong>Fecha:</strong> {transaccion.fecha}
        </li>
        <li className="list-group-item">
          <i className="bi bi-credit-card me-2"></i>
          <strong>Medio de pago:</strong> {transaccion.medioPago}
        </li>
        <li className="list-group-item">
          <i className="bi bi-123 me-2"></i>
          <strong>Cantidad:</strong> {transaccion.cantidad || 'N/A'}
        </li>
      </ul>
      <Row className="g-0 gy-2 justify-content-center">
        {tickets.length > 0 ? (
          tickets.map((num, index) => (
            <Col className="tight-col" xs={3} sm={2} md={2} lg={1} key={index}>
              <Ticket
                numeroTicket={num}
                // Mostrar el boleto igual que en la compra (boletoA.png)
                esPremiado={false}
              />
            </Col>
          ))
        ) : (
          <p>No tienes tickets disponibles.</p>
        )}
      </Row>
      </Card.Body>
    </Card>
  );
};

export default EstadoTransaccion;
